export const PAGE_SIZE = 100;

export function getMaxPageIndex(itemCount: number): number {
  return Math.max(0, Math.ceil(itemCount / PAGE_SIZE) - 1);
}
